// extracted by mini-css-extract-plugin
export default {"information":"styles_information__Jurou","title":"styles_title__FHLH2","content":"styles_content__rHt5U","titleinput":"styles_titleinput__BGT-S"};